module.exports = __webpack_public_path__ + "static/media/filter_icon.4392cf99.svg";